const API_URL = process.env.REACT_APP_API_URL || 'https://api.display-promo.ru';

let token = null;

export function setToken(newToken) {
    token = newToken;
    if (newToken) localStorage.setItem('jwt', newToken);
    else localStorage.removeItem('jwt');
}

export function getToken() {
    return token || localStorage.getItem('jwt');
}

function buildHeaders(extra = {}, body) {
    const headers = { ...extra };
    // Не ставим Content-Type для FormData — браузер выставит boundary сам
    if (!(body instanceof FormData) && !headers['Content-Type']) {
        headers['Content-Type'] = 'application/json';
    }
    const jwt = getToken();
    if (jwt) headers['Authorization'] = `Bearer ${jwt}`;
    return headers;
}

export async function apiFetch(url, opts = {}) {
    const headers = buildHeaders(opts.headers || {}, opts.body);
    const config = { ...opts, headers };
    const res = await fetch(API_URL + url, config);

    if (res.status === 401) {
        setToken(null);
        window.location.href = '/login';
        throw new Error('Unauthorized');
    }
    if (res.status === 204) return null;

    const text = await res.text();
    const data = text ? JSON.parse(text) : null;

    if (!res.ok) {
        const msg = data?.error || data?.message || `API error ${res.status}`;
        throw new Error(msg);
    }
    return data;
}

// ---------- Аутентификация ----------
export async function login(email, password) {
    const res = await fetch(API_URL + '/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
    });
    if (!res.ok) throw new Error('Неверные данные');
    const data = await res.json();
    setToken(data.token);
    return data;
}

export const getMe = () => apiFetch('/api/me');

// ---------- Плейлисты ----------
export const getPlaylists = () => apiFetch('/admin/playlists');
export const createPlaylist = (payload) => apiFetch('/admin/playlists', { method: 'POST', body: JSON.stringify(payload) });
export const updatePlaylist = (id, payload) => apiFetch(`/admin/playlists/${id}`, { method: 'PUT', body: JSON.stringify(payload) });
export const deletePlaylist = (id) => apiFetch(`/admin/playlists/${id}`, { method: 'DELETE' });
export const copyPlaylist = (id, payload = {}) => apiFetch(`/admin/playlists/${id}/copy`, { method: 'POST', body: JSON.stringify(payload) });
export const savePlaylistOrder = (playlistId, orderedItems) =>
    apiFetch('/admin/playlists/savePlaylistOrder', { method: 'POST', body: JSON.stringify({ idPlayList: playlistId, playList: orderedItems }) });
export const getPlaylistFiles = (playlistId) => apiFetch(`/admin/playlists/${playlistId}/files`);

// Файлы в плейлист
export const addFileToPlaylist = (playlistId, payload) =>
    apiFetch(`/admin/playlists/${playlistId}/files`, { method: 'POST', body: JSON.stringify(payload) });
export const removeFileFromPlaylist = (playlistId, filePlayListId) =>
    apiFetch(`/admin/playlists/${playlistId}/files/${filePlayListId}`, { method: 'DELETE' });

// ---------- Компании и устройства ----------
export const getCompaniesWithDevices = () => apiFetch('/admin/playlists/companies-with-devices');
export const setCompanyPlaylist = ({ playlistId, companyId, active }) =>
    apiFetch('/admin/playlists/setCompanyPlaylist', { method: 'POST', body: JSON.stringify({ playlistId, companyId, active }) });

// ---------- Глобальные файлы ----------
export const listFiles = () => apiFetch('/admin/files');

export async function uploadFile({ file, title = '' }) {
    const form = new FormData();
    form.append('file', file);
    form.append('title', title);
    const headers = buildHeaders({}, form);
    const res = await fetch(API_URL + '/admin/files', { method: 'POST', headers, body: form });

    if (res.status === 401) {
        setToken(null);
        window.location.href = '/login';
        throw new Error('Unauthorized');
    }
    if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.error || 'Upload error');
    }
    return res.json();
}

export const updateFileMeta = (id, payload) => apiFetch(`/admin/files/${id}`, { method: 'PUT', body: JSON.stringify(payload) });
export const softDeleteFile = (id) => apiFetch(`/admin/files/${id}`, { method: 'DELETE' });

export { API_URL };
